import { CalendarDaysSolid } from '@allocab/allocab-icons';
import dayjs from 'dayjs';
import { useCallback, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { twJoin } from 'tailwind-merge';

import { DatePicker } from '../../components/date-picker/DatePicker';
import { FilterBadge } from '../../components/FilterBadge';
import { useOnClickOutside } from '../../hooks/useOnClickOutside';
import { t } from '../../services/translation/translation';

export const DEPARTURE_AT_FILTER_FORMAT = 'DD-MM-YYYY';
export const DEPARTURE_DAY_SEARCH_PARAMS_KEY = 'departureDay';

type Props = {
  onChange: (_key: string, _value: string | undefined) => void;
};

export const TripDepartureAtFilter = ({ onChange }: Props) => {
  const [searchParams] = useSearchParams();
  const [isVisible, setIsVisible] = useState(false);
  const departureDay = searchParams.get(DEPARTURE_DAY_SEARCH_PARAMS_KEY);
  const isActive = !!departureDay;

  const ref = useOnClickOutside(
    useCallback(() => {
      setIsVisible(false);
    }, []),
  );

  const handleChange = useCallback(
    (timestamp: number | undefined) => {
      if (timestamp) {
        onChange(DEPARTURE_DAY_SEARCH_PARAMS_KEY, dayjs(timestamp).format(DEPARTURE_AT_FILTER_FORMAT));
      } else {
        onChange(DEPARTURE_DAY_SEARCH_PARAMS_KEY, undefined);
      }
      setIsVisible(false);
    },
    [onChange],
  );

  return (
    <div className="relative flex items-center justify-center">
      <FilterBadge onClick={() => setIsVisible(v => !v)} isActive={isActive}>
        <CalendarDaysSolid width={12} height={12} className="fill-current" />
        <span>
          {isActive && departureDay
            ? dayjs(departureDay, DEPARTURE_AT_FILTER_FORMAT).format(t('date.date-longer'))
            : t('common.date')}
        </span>
      </FilterBadge>

      {isVisible ? (
        <div
          ref={ref}
          className={twJoin(
            'absolute top-10 z-10 w-48 bg-white rounded-lg shadow dark:bg-gray-700',
            !isVisible && 'hidden',
          )}
        >
          <DatePicker
            onChange={handleChange}
            initialDate={departureDay ? dayjs(departureDay, DEPARTURE_AT_FILTER_FORMAT).valueOf() : undefined}
          />
        </div>
      ) : null}
    </div>
  );
};
